<deprecated-labeled-field [label]="label" [help]="help" [required]="required">
  <textarea
    #textareaElement
    [placeholder]="placeholder"
    [required]="required"
    [disabled]="disabled"
    [readonly]="readonly"
    [value]="value"
    (input)="value = $event.target.value"
    [attr.rows]="rows"
    [focusOnInit]="autoFocus"
    tabindex="0"
  ></textarea>
</deprecated-labeled-field>
